module.exports = __webpack_public_path__ + "static/media/Library Books.efc3498d.png";